<!--
<template>
  <div>
    <h2>Register</h2>
    <form @submit.prevent="register">
      <input v-model="username" type="text" placeholder="Username" required />
      <input v-model="password" type="password" placeholder="Password" required />
      <input v-model="email" type="email" placeholder="Email" required />
      <vue-recaptcha sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" @verify="onCaptchaVerified"></vue-recaptcha>
      <button type="submit">Register</button>
    </form>
  </div>
</template>
-->

<template>
  <div class="container mt-5">
    <h2 class="text-center">Register</h2>
    <form @submit.prevent="register" class="row g-3">
      <div class="col-md-6 offset-md-3">
        <div class="form-floating mb-3">
          <input
            v-model="username"
            type="text"
            class="form-control"
            id="username"
            placeholder="Username"
            required
          />
          <label for="username">Username</label>
        </div>
      </div>
      <div class="col-md-6 offset-md-3">
        <div class="form-floating mb-3">
          <input
            v-model="password"
            type="password"
            class="form-control"
            id="password"
            placeholder="Password"
            required
          />
          <label for="password">Password</label>
        </div>
      </div>
      <div class="col-md-6 offset-md-3">
        <div class="form-floating mb-3">
          <input
            v-model="email"
            type="email"
            class="form-control"
            id="email"
            placeholder="Email"
            required
          />
          <label for="email">Email</label>
        </div>
      </div>
      <div class="col-md-6 offset-md-3">
        <vue-recaptcha sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" @verify="onCaptchaVerified"></vue-recaptcha>
      </div>
      <div class="col-md-6 offset-md-3 text-center">
        <button type="submit" class="btn btn-primary">Register</button>
      </div>
    </form>
  </div>
</template>

<script>
import VueRecaptcha from 'vue3-recaptcha2'
import axios from 'axios'

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      username: '',
      password: '',
      email: '',
      captchaVerified: false
    }
  },
  methods: {
    onCaptchaVerified(response) {
      this.captchaVerified = true
    },
    async register() {
      if (!this.captchaVerified) {
        alert('Please verify the captcha')
        return
      }

      const payload = {
        user: this.username+'@phive',
        passwd: this.password,
        email: this.email
      }

      try {
        const response = await axios.post(this.PhiveHost+'/cgi-bin/userreg.cgi', payload, { params: {cmd: "info"}, headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        if (response.data.code === 0) {
          this.$router.push('/login')
        } else {
          alert(response.data.msg)
        }
      } catch (error) {
        console.error(error)
        alert('Registration failed')
      }
    }
  }
}
</script>
